// extracted by mini-css-extract-plugin
module.exports = {"validate":"resetpassword_validate__pYLuv"};